

import {useRoute, useRouter} from "vue-router";

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    price_lock: number;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof formType;
var editor: any = null;
const columnList: Array<column> = [
    {
        prop: "name",
        label: "服务名称",
        width: 155,
    },
    {
        prop: "project_type_name",
        label: "服务类型",
        width: 155,
    },
    {
        prop: "middle_price",
        label: "工时费（中）",
        width: 155,
    },
    // {
    //     prop: "original_price",
    //     label: "售价",
    //     width: 155,
    // },
    // {
    //     prop: "present_price",
    //     label: "优惠价",
    //     width: 155,
    // },
    // {
    //     prop: "vip_class_name",
    //     label: "可用卡类型",
    //     width: 155,
    // }
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetProject,
    // 服务分类列表
    getProjectTypeList,
    // 尊享卡分类列表
    getVipClassList,
    getLevelBackList,
    getQiNiuYunToken, permissionList, getStoreTotalList
} from "@/api/http";
import { validateInput, validateClass } from "@/assets/js/formRules";
import { formType,column } from "@/assets/types/common";
import { Request } from '@/api/request';
import wangEditor from 'wangeditor';
import { ElMessage } from "element-plus";

const qiniu: any = require("qiniu-js");
export default defineComponent({
    name: "projectService",
    setup() {
        const Router = useRouter();
        const Route = useRoute();
        const setTitle: any = inject("setTitle");
        setTitle(["服务项目"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            store_ids = ref([]),
            tableData = ref([] as Array<parts>),
            LevelBackList = ref([] as Array<parts>),
            total = ref(0),
            is_admin = ref(false),
            roleList = ref({} as any),
            loading = ref(true),
            imgLoading = ref(false),
			editorRef = ref(),
			bannerLoading = ref(false),
			exhibitionUrl = ref({ url: "", key: "" }),
            img = ref({ url: "", key: "" }),
            // 筛选
            selectGroup = reactive({
                status: "",
                project_type_pid: "",
                search: "",
            }),
            select = reactive({
                project_type_list: [],
                vip_class_list: [],
            }),
            remote_loading = ref(false),
            dialogFormVisible = ref(false),
            dialog_title = ref("新增维修项目"),
			bannerImg = ref([] as Array<string>),
            formRef = ref(null),
			bucketURL = "",
			uploadType = true,
			token = "",
			form = ref({
				id: null,
				name: '',
				project_type_pid: '',
				low_price: '',
				middle_price: '',
				high_price: '',
                is_show: 0,
				original_price: '',
				present_price: '',
                build_bonus_type: 1,
                build_bonus_price: null,
                sell_bonus_type: 1,
                sell_bonus_price: null,
				img: {},
                store_ids:"",
                sort:9999
			} as any),
            commissionType = ref(["固定金额", "业绩比例"]),
            isEdit = ref(false),
			bannerKey: Array<string> = [],
            rules = reactive({
                // img: [
                //     {
                //         required: true,
                //         validator: (
                //             rule: any,
                //             value: string,
                //             callback: Function
                //         ) => {
                //             if (img.value.key) {
                //                 callback();
                //             } else {
                //                 callback(new Error("请上传服务图片"));
                //             }
                //         },
                //         trigger: "change",
                //     },
                // ],
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入项目名称", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                project_type_pid: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请选择服务分类", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                low_price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("该项必填", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                middle_price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("该项必填", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                high_price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("该项必填", value, callback);
                        },
                        trigger: "change",
                    },
                ],
				// original_price: [
				// 	{
				// 		required: true,
                //         validator: (
                //             rule: any,
                //             value: string,
                //             callback: Function
                //         ) => {
                //             validateInput("该项必填", value, callback);
                //         },
				// 		 trigger: 'change',
				// 	},
				// ],
				
            }),
			fileList =  ref([] as any)
			
			
		let beforeAvatarUpload = (file: File) => {
				const isJPG = file.type === "image/jpeg";
				const isPNG = file.type === "image/png";
				if (!isJPG && !isPNG) {
					ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
				}
				return isJPG && isPNG;
			},
			handleChange = (file: any, type: boolean) => {
				uploadImg(file.raw).then((res: any) => {
					let url = 
					img.value = {
						url: bucketURL + res.key,
						key: res.key,
					};
				  
				})
			},
            partsManage = (id:any)=>{
                Router.push({
                    path: '/project/projectParts',
                    query: {
                        project_id: id,
                    }
                })
            },
			imgLoad = () => {
				imgLoading.value = false;
			},
			
			handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
				Request.axiosInstance({
					url: 'adminapi/Project/list',
					data: {
						pagesize:pageSize.value,
						page:currentPage.value,
                        ...selectGroup
					}
				}).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.count || 0;
                });
                let data = {
                    type:1,
                    role_name:'project_service',
                }
                permissionList(data).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
				getLevelBackList({}).then((res: any) => {
					console.log(res)
					LevelBackList.value = res?.content?.list || []
				});
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getProjectTypeList({}).then((res: any) => {
					select.project_type_list = res?.content?.list;
					remote_loading.value = false;
                });
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectProjectTypeChange = (e: number) => {
                form.value.project_type_pid = e;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            screenChange = (e: any, key: string): void => {
                
                getTableData();
            },
            columnChange = ( item: any ,type: boolean) => {
                if (type) {
					Request.axiosInstance({
						url: 'adminapi/Project/info',
						data: {id: item.id}
					}).then((res: any) => {
						form.value = res.content.list
                        let need_arr = [];
                        if (res.content.list.public_store){
                            for (const arrElement of res.content.list.public_store.split(',')) {
                                need_arr.push(Number(arrElement));
                            }
                        }
                        form.value.store_ids = need_arr;
						fileList.value = [];
						if(form.value.img.url){
							img.value = {
								url:form.value.img.url,
								key:form.value.img.key
							}
						}
						dialog_title.value = "编辑"
						dialogFormVisible.value = true
						
							if(!editor)
							{
                                setTimeout(() => {
                                    editor = new wangEditor('#editor')
                                    editor.config.menus = [
                                        'head',
                                        'bold',
                                        'fontSize',
                                        'fontName',
                                        'italic',
                                        'underline',
                                        'strikeThrough',
                                        'indent',
                                        'lineHeight',
                                        'foreColor',
                                        'backColor',
                                        'link',
                                        'list',
                                        'quote',
                                        'image',
                                        'video',
                                        'table',
                                        'splitLine',
                                        'undo',
                                    ]
                                    editor.config.customUploadImg = function (resultFiles: any, insertImgFn: any) {
                                        // resultFiles 是 input 中选中的文件列表
                                        // insertImgFn 是获取图片 url 后，插入到编辑器的方法
                                        console.log(resultFiles)
                                        // 上传图片，返回结果，将图片插入到编辑器中
                                        if(resultFiles.length > 1){
                                            ElMessage.error("只可选择一张!");
                                            return
                                        }
        
        
                                        for(var i = 0; i < resultFiles.length; i++)
                                        {
                                            if (!(resultFiles[i].type != "image/jpeg" || resultFiles[i].type != "image/png")) {
                                                ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                                                return
                                            }
            
                                            //uploadImg(resultFiles[i].)
            
                                        }
        
                                        uploadImg(resultFiles[0]).then((res: any) => {
                                            let url = bucketURL + res.key
                                            insertImgFn(url)
            
                                        })
                                    }
                                    editor.create()
                                    editor.txt.html(form.value.describe);
                                },1000)
                                
								
								
							}
							else {
                                editor.txt.html(form.value.describe);
                            }
                            
						
					})
                } else {
                    getSetProject({
                        id: item.id,
                        status: item.status == 1 ? 2 : 1,
                    }).then((res) => getTableData());
                }
            },
            submitForm = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid) return
					let url = 'adminapi/Project/edit';
					form.value.img = img.value.url;
					// 读取富文本内容
					form.value.describe = editor.txt.html();
					if (form.value.store_ids){
                        form.value['store_list'] = form.value.store_ids.toString();
                    }
					if(dialog_title.value != '编辑'){
						url = 'adminapi/Project/post';
						delete form.value.id;
					}
                    Request.axiosInstance({
						url,
						data: {...form.value}
					}).then((res: any) => {
						if (res.status == 202){
                            dialogFormVisible.value = false
                            getTableData()
                        }
					})
					
					
                });
            },
			_add = () => {
                if(formRef.value){
                    (formRef.value as any).resetFields();
                }
                fileList.value = []
                form.value = []
                img.value = {
                    url:'',
                    key:''
                }
				dialog_title.value = '新增服务'
				dialogFormVisible.value = true
     
					if(!editor)
					{
                        setTimeout(() => {
                            editor = new wangEditor('#editor')
                            editor.config.menus = [
                                'head',
                                'bold',
                                'fontSize',
                                'fontName',
                                'italic',
                                'underline',
                                'strikeThrough',
                                'indent',
                                'lineHeight',
                                'foreColor',
                                'backColor',
                                'link',
                                'list',
                                'quote',
                                'image',
                                'video',
                                'table',
                                'splitLine',
                                'undo',
                            ]
                            editor.config.customUploadImg = function (resultFiles: any, insertImgFn: any) {
                                // resultFiles 是 input 中选中的文件列表
                                // insertImgFn 是获取图片 url 后，插入到编辑器的方法
                                console.log(resultFiles)
                                // 上传图片，返回结果，将图片插入到编辑器中
                                if(resultFiles.length > 1){
                                    ElMessage.error("只可选择一张!");
                                    return
                                }
        
        
                                for(var i = 0; i < resultFiles.length; i++)
                                {
                                    if (!(resultFiles[i].type != "image/jpeg" || resultFiles[i].type != "image/png")) {
                                        ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                                        return
                                    }
            
                                    //uploadImg(resultFiles[i].)
            
                                }
        
                                uploadImg(resultFiles[0]).then((res: any) => {
                                    let url = bucketURL + res.key
                                    insertImgFn(url)
            
                                })
                            }
                            editor.create()
                            editor.txt.html(form.value.describe);
                        },1000)
						
					}else {
                        editor.txt.html('');
                    }
    
                    
                
			},
			uploadImg = (file: any) => {
				
                return new Promise((resolve: any, rejetc) => {
                    let config = {
			        useCdnDomain: true,
			        // region: qiniu.region.z2,
                    };
                    let putExtra = {
                        fname: "",
                        params: {},
                        mimeType: null,
                    };
                    let observable: any = {};

                    observable = qiniu.upload(file, null, token, putExtra, config);
                    const observer = {
                        next(res: any) {},
                        error(err: any) {},
                        complete(res: any) {

                            resolve(res)
                        },
                    };
                    observable.subscribe(observer);
                })
			    
			}
        onMounted(() => {
    
    
            setTimeout(() => {
                editor = new wangEditor('#editor')
                editor.config.menus = [
                    'head',
                    'bold',
                    'fontSize',
                    'fontName',
                    'italic',
                    'underline',
                    'strikeThrough',
                    'indent',
                    'lineHeight',
                    'foreColor',
                    'backColor',
                    'link',
                    'list',
                    'quote',
                    'image',
                    'video',
                    'table',
                    'splitLine',
                    'undo',
                ]
                editor.config.customUploadImg = function (resultFiles: any, insertImgFn: any) {
                    // resultFiles 是 input 中选中的文件列表
                    // insertImgFn 是获取图片 url 后，插入到编辑器的方法
                    console.log(resultFiles)
                    // 上传图片，返回结果，将图片插入到编辑器中
                    if(resultFiles.length > 1){
                        ElMessage.error("只可选择一张!");
                        return
                    }
            
            
                    for(var i = 0; i < resultFiles.length; i++)
                    {
                        if (!(resultFiles[i].type != "image/jpeg" || resultFiles[i].type != "image/png")) {
                            ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                            return
                        }
                
                        //uploadImg(resultFiles[i].)
                
                    }
            
                    uploadImg(resultFiles[0]).then((res: any) => {
                        let url = bucketURL + res.key
                        insertImgFn(url)
                
                    })
                }
                editor.create()
                editor.txt.html(form.value.describe);
            },1000)
            let info;
            let user_info = localStorage.getItem('user_info');
            if (user_info) {
                info = JSON.parse(user_info);
                if (info.store_id==0){
                    is_admin.value = true;
                }
            }
            getStoreTotalList({}).then((res:any)=>{
                store_ids.value = res?.content?.list;
            });
            getTableData();
            getSelectData({});
			getQiNiuYunToken().then((res: any) => {
			    token = res.content.token;
			    bucketURL = res.content.domain;
			});
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
			
    
        });

        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            LevelBackList,
            total,
            loading,
            img,
            imgLoading,
            selectGroup,
            select,
            remote_loading,
            dialogFormVisible,
            dialog_title,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            remoteBrand,
            formSelectProjectTypeChange,
            bonusSelectChange,
            columnChange,
            submitForm,
			fileList,
			editorRef,
			_add,
			editor,
			beforeAvatarUpload,
			handleChange,
			uploadImg,
			bannerLoading,
			exhibitionUrl,
			bannerImg,
			bucketURL,
			bannerKey,
            roleList,
            partsManage,
            is_admin,
            store_ids,
            screenChange
        };
    },
});
